import Style from "../index.module.css";

export default function Step3({ prevStep, isLoading }) {
  return (
    <div className={Style.step}>
      <h2>Confirmação</h2>
      <p
        style={{
          fontSize: "10pt",
          marginBottom: 8
        }}
      >
        Seu cadastro será enviado para análise. Após a aprovação, você receberá um e-mail de confirmação e nosso questionário padrão para complementar as informações.
      </p>
      <div className={Style.buttonGroup}>
        <button
          type="button"
          className={`${Style.button} ${Style.buttonSecondary}`}
          onClick={prevStep}
          disabled={isLoading}
        >
          Voltar
        </button>
        <button
          type="submit"
          className={`${Style.button} ${Style.buttonPrimary}`}
          disabled={isLoading}
        >
          {isLoading ? "Enviando..." : "Enviar"}
        </button>
      </div>
    </div>
  );
}


